export type LoginParams = {
  username: string;
  password: string;
}

export type JwtTokens = {
  access: string;
  refresh: string;
}

export type UserRole = 'ROLE_USER' | 'ROLE_MANAGER' | 'ROLE_ADMIN' |
  'ROLE_REVIEWER' | 'ROLE_DOCUMENT_EDITOR' | 'ROLE_DOCUMENT_MANAGER' |
  'ROLE_PROMOTION_SPECIALIST' | 'ROLE_DESIGNER' | 'ROLE_PURCHASING_MANAGER' |
  'ROLE_MARKETPLACE_MANAGER' | 'ROLE_MARKETPLACE_HEAD' | 'ROLE_BRAND_MANAGER';

export const roleDescriptions: { [key in UserRole]: string } = {
  ROLE_ADMIN: 'Администратор',
  ROLE_USER: 'Пользователь',
  ROLE_MANAGER: 'Менеджер',
  ROLE_REVIEWER: 'Проверяющий',
  ROLE_DOCUMENT_EDITOR: 'Документооборот',
  ROLE_DOCUMENT_MANAGER: 'Менеджер документов',
  ROLE_PROMOTION_SPECIALIST: 'Специалист по продвижению',
  ROLE_DESIGNER: 'Дизайнер',
  ROLE_PURCHASING_MANAGER: 'Закупщик-продуктолог',
  ROLE_MARKETPLACE_MANAGER: 'Менеджер маркетплейсов',
  ROLE_MARKETPLACE_HEAD: 'Руководитель маркетплейсов',
  ROLE_BRAND_MANAGER: 'Бренд менеджер'
};

export type CurrentUserRoleAndLogin = {
  displayRole: string;
  role: string;
  login: string;
}
